

























































import {Component, Prop, Vue} from 'vue-property-decorator'
import {GithubOrganizationSocialType} from '@/model/resource/GithubOrganizationSocialType'

@Component({})
export default class CDOrganizationSocialLinks extends Vue {
  @Prop({type: Array, default: () => []})
  socialTypes!: GithubOrganizationSocialType[]
}
